export const validationPatterns = {
  name: /^(?=.{2,50}$)[A-Za-z]+(?: [A-Za-z]+)*$/,
  keyDownName: /^[a-zA-Z ]*$/,
  passwordRegex: (minL, maxL) => {
    return new RegExp(
      `^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%^&*])[a-zA-Z0-9!@#$%^&*]{${minL},${maxL}}$`
    );
  },
};
